/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Emailtemplate_Description2Inputs */

const en_coinvestments_emailtemplate_description2 = /** @type {(inputs: Coinvestments_Emailtemplate_Description2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Set the subject and body used for this deal's outreach emails. Both are pre-filled with the platform default — edit them as needed. Use the buttons above the editor to insert placeholders, which are filled in per recipient when the email is sent.`)
};

/**
* | output |
* | --- |
* | "Set the subject and body used for this deal's outreach emails. Both are pre-filled with the platform default — edit them as needed. Use the buttons above the..." |
*
* @param {Coinvestments_Emailtemplate_Description2Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_emailtemplate_description2 = /** @type {((inputs?: Coinvestments_Emailtemplate_Description2Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Emailtemplate_Description2Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_emailtemplate_description2(inputs)
});
export { coinvestments_emailtemplate_description2 as "coInvestments_emailTemplate_description" }